export const PARTNERS_FILTER_INITIAL_VALUE = {
  searchFilter: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export type PartnersFilterParams = {
  searchFilter?: string;
};
export type SetPartnersFilterParams = (params: PartnersFilterParams) => void;
